import { render, staticRenderFns } from "./Legalization.vue?vue&type=template&id=5e0939d0&scoped=true&"
import script from "./Legalization.vue?vue&type=script&lang=js&"
export * from "./Legalization.vue?vue&type=script&lang=js&"
import style0 from "./Legalization.vue?vue&type=style&index=0&id=5e0939d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0939d0",
  null
  
)

export default component.exports